// extracted by mini-css-extract-plugin
export default {"title":"AuthCodeForm_title__IoMFC","form":"AuthCodeForm_form__xiYuE","message":"AuthCodeForm_message__wWyQ8"};